import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

export default class EpisodeCardComponent extends Component {
  init() {
    this.element.addEventListener('click', this.onClick)
  }

  onClick(event) {
    if (!event.currentTarget.href) {
      return
    }

    const episodeId = event.currentTarget.getAttribute('data-episode-id')

    if (!episodeId) {
      return
    }

    event.preventDefault()
    window.dispatchEvent(new CustomEvent('episode-overlay', { detail: { episodeId } }))
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'episode-card', EpisodeCardComponent))
